import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    // If clicking Production & Pricing, navigate to that page
    if (id === 'production-pricing') {
      navigate('/production-pricing');
      setIsMobileMenuOpen(false);
      window.scrollTo(0, 0);
      return;
    }
    
    // If we're on production-pricing page, go home first
    if (location.pathname === '/production-pricing') {
      navigate('/');
      setTimeout(() => {
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    } else {
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
        setIsMobileMenuOpen(false);
      }
    }
  };

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      isScrolled ? 'bg-black/95 backdrop-blur-sm border-b border-gold/20' : 'bg-transparent'
    }`}>
      <nav className="max-w-7xl mx-auto px-6 py-6 flex items-center justify-between">
        <div className="text-2xl font-playfair font-bold">
          <span className="text-gold">M</span>E
        </div>
        
        {/* Desktop Menu */}
        <ul className="hidden md:flex items-center space-x-8 text-sm tracking-wide">
          <li>
            <button onClick={() => scrollToSection('home')} className="hover:text-gold transition-colors">
              HOME
            </button>
          </li>
          <li>
            <button onClick={() => scrollToSection('work')} className="hover:text-gold transition-colors">
              WORK
            </button>
          </li>
          <li>
            <button onClick={() => scrollToSection('about')} className="hover:text-gold transition-colors">
              ABOUT
            </button>
          </li>
          <li>
            <button onClick={() => scrollToSection('production-pricing')} className="hover:text-gold transition-colors">
              PRODUCTION & PRICING
            </button>
          </li>
          <li>
            <button 
              onClick={() => scrollToSection('contact')} 
              className="px-6 py-2 border border-magenta text-magenta hover:bg-magenta hover:text-white transition-all duration-300"
            >
              CONTACT
            </button>
          </li>
        </ul>

        {/* Mobile Menu Button */}
        <button 
          className="md:hidden text-gold"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
        >
          {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </nav>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-black/98 border-t border-gold/20">
          <ul className="px-6 py-8 space-y-6 text-sm tracking-wide">
            <li>
              <button onClick={() => scrollToSection('home')} className="block hover:text-gold transition-colors">
                HOME
              </button>
            </li>
            <li>
              <button onClick={() => scrollToSection('work')} className="block hover:text-gold transition-colors">
                WORK
              </button>
            </li>
            <li>
              <button onClick={() => scrollToSection('about')} className="block hover:text-gold transition-colors">
                ABOUT
              </button>
            </li>
            <li>
              <button onClick={() => scrollToSection('production-pricing')} className="block hover:text-gold transition-colors">
                PRODUCTION & PRICING
              </button>
            </li>
            <li>
              <button 
                onClick={() => scrollToSection('contact')} 
                className="block px-6 py-2 border border-magenta text-magenta hover:bg-magenta hover:text-white transition-all duration-300 text-center"
              >
                CONTACT
              </button>
            </li>
          </ul>
        </div>
      )}
    </header>
  );
};

export default Header;